/**
 * idl https://vrfi1sk8a0.feishu.cn/wiki/Z6KgwOO0Oiqq4akJdyhcbLs2n6c
 */
import { EGender, ENpcAgentType } from './chat';
import { EModerationDecision, ENextVersionStatus } from './feed';
import { IHeadPosition } from './npcBase';
import { PluginInfo } from './plugin';

export enum ChatModelType {
  Chat = 1,
  Util = 2,
  Real = 3,
}

export interface ImInfo {
  im_account: string;
}

export interface ModerationDetail {
  final_decision: number; // TODO 为啥不是枚举
}

export enum WorkspaceListReqType {
  All = 0,
  Draft = 1,
  InModeration = 2,
}

export interface WorkspaceNpcSettingInfo {
  npc_name?: string;
  gender?: EGender;
  desc?: string;
  prologue?: string;
  long_desc?: string;
  chat_model_type?: ChatModelType;
  npc_agent_type?: ENpcAgentType;
}

export interface WorkspaceNpcVoiceInfo {
  npc_tone?: Record<string, number>;
  speed?: number;
  pitch?: number;
}

export interface WorkspaceNpcImgInfo {
  base_img_url?: string;
  face_img_url?: string;
  head_position?: IHeadPosition;
  avatar_material_id?: number;
}

export interface WorkspaceNpcStatusInfo {
  moderation_detail: ModerationDetail;
  last_submitted_time: number; // 上次发布时间，如果为0的话则是从未发布，是纯草稿
  is_demo: boolean; // 是否是示例npc，是的话不允许发布
  next_version_status: ENextVersionStatus;
  final_decision: EModerationDecision; // // 当前版本审核状态
  edit_version: number; // 当前版本号
  create_timestamp: number;
  update_timestamp: number;
  avatar_from_phone_album: boolean;
  desc_has_upgrade?: boolean;
}

export interface WorkspaceNpcInfo {
  npc_id: number;
  setting_info: WorkspaceNpcSettingInfo;
  voice_info: WorkspaceNpcVoiceInfo;
  img_info: WorkspaceNpcImgInfo;
  status_info: WorkspaceNpcStatusInfo;
  im_info: ImInfo;
  plugin_list: PluginInfo[];
  conversation_npc_id?: number;
}

export interface WorkSpaceBanner {
  banner_id: number;
  img_url: string; // 图像url
  jump_url: string; // 跳转url
}

export interface GetWorkspaceListReq {
  req_type: WorkspaceListReqType;
  page: number;
  size: number;
  max_create_time: number;
}

export interface GetWorkspaceListResp {
  workspace_npc_info: WorkspaceNpcInfo[];
  has_more: boolean;
  next_page: number;
  total_size: number;
  min_create_time: number;
}

export interface GetWorkspaceDetailReq {
  npc_id: number;
}

export interface GetWorkspaceDetailResp {
  workspace_npc_info: WorkspaceNpcInfo;
}

export interface UpsertWorkspaceDraftReq {
  npc_id?: number;
  setting_info?: WorkspaceNpcSettingInfo;
  voice_info?: WorkspaceNpcVoiceInfo;
  img_info?: WorkspaceNpcImgInfo;
  plugin_list?: PluginInfo[];
  npc_trace_info?: {
    ai_write_trace_info?: string;
  };
}

export interface UpsertWorkspaceDraftResp {
  npc_info: WorkspaceNpcInfo;
}

export interface SubmitWorkspaceDraftReq {
  npc_id: number;
}

export enum SubmitFailedReason {
  IsDemo = 1, // 示例
  UnderModeration = 2, // 审核中
}

export interface SubmitWorkspaceDraftResp {
  fail_reason?: SubmitFailedReason;
  fail_message?: string;
}

export interface DeleteWorkspaceDraftReq {
  npc_id: number;
}

export interface DeleteWorkspaceDraftResp {}

export interface GetNpcPrologueVoiceReq {
  npc_id: number;
  edit_version?: number;
  npc_phase_value?: number;
  from_workspace?: boolean;
}

export interface GetNpcPrologueVoiceResp {
  prologue_voice_duration: number;
  prologue_voice_url: string;
}

export enum NpcFieldType {
  NpcName = 1,
  NpcDesc = 2,
  NpcPrologue = 3,
  NpcExampleDialogue = 4,
  CardTitle = 5,
  CardStory = 6,
  DialogueTemplateTitle = 7,
  DialogueTemplateDescription = 8,
  DialogueTemplateExampleDialogue = 9,
  NpcToneName = 10,
  NpcPrompt = 11,
  NpcTag = 12,
  CardPrompt = 13,
  CardStoryPrologue = 14,
  CardStoryMissionObjective = 15,
  CardStoryMissionCondition = 16,
  FieldType_FiledSeriesName = 17,
  FieldType_FiledSeriesDescription = 18,
  FieldType_FiledSeriesComment = 19,
  FieldType_FiledCardImage = 20,
  GroupChatName = 21,
  GroupChatDesc = 22,
  GroupChatRelationship = 23,
  GroupPrologue = 24,
  NpcLongDesc = 25,
  PlotTitle = 26,
  PlotDesc = 27,
  PlotPrologue = 28,
  PlotMissionObjective = 29,
  PlotMissionCondition = 30,
  PlotImg = 31,
  VoiceDesc = 32,
  GameName = 33,
  GameDesc = 34,
  GamePrologue = 35,
  GameProgressBarName = 36,
  GameAiHostPrompt = 37,
  GameAiJudgerPrompt = 38,
  MomoryTitle = 39,
  MomoryContent = 40,
  NpcBaseImg = 41,
  NpcSmallHead = 42,
  ProgressBarName = 43,
  ProgressBarDesc = 44,
  ProgressBarRule = 45,
  NpcTone = 46,
  ProgressPrologue = 47,
  ProgressDesc = 48,
  ProgressHiddenDesc = 49,
}

export const NpcFieldMap: Record<NpcFieldType, string | undefined> = {
  [NpcFieldType.NpcName]: 'npc_name',
  [NpcFieldType.NpcDesc]: 'npc_desc',
  [NpcFieldType.NpcPrologue]: 'npc_prologue',
  [NpcFieldType.NpcLongDesc]: 'npc_long_desc',
  [NpcFieldType.NpcBaseImg]: 'npc_base_img',
  [NpcFieldType.NpcPrompt]: 'npc_prompt',
} as Record<NpcFieldType, string | undefined>;

export interface DraftModerationReq {
  npc_id: number;
  setting_info?: Partial<WorkspaceNpcSettingInfo>;
  img_info?: Partial<WorkspaceNpcImgInfo>;
  plugin_list?: PluginInfo[];
}

export interface DraftModerationResp {
  not_pass_field_list: NpcFieldType[];
}

export interface GetWorkspaceBannerReq {}

export interface GetWorkspaceBannerResp {
  banner_list: WorkSpaceBanner[];
}

export interface GetChatModelsResp {
  chat_model_detail: {
    chat_model_tab: string;
    chat_model_meta_list: {
      chat_model_type: ChatModelType;
      chat_model_name: string;
      chat_model_detail: string;
    }[];
  };
  interactive_detail: {
    interactive_tab: string;
    interactive_meta_list: {
      interactive_type: number;
      interactive_name: string;
      interactive_detail: string;
    }[];
  };
}
